import * as type from './types'


export function createLedgermap(ledgermap) {
    return {
        type : type.CREATE_LEDGERMAP,
        payload : ledgermap,
        txn : 'initiated',
    };
}


export function savedLedgermap(ledgermap, status = 'success', msg = 'Saved successfully.') {
    return {
        type : type.SAVED_LEDGERMAP,
        payload : ledgermap,
        txn : status,
        msg,
        diff : true
    };
}


export function editLedgermap(ledgermap) {
    return {
        type : type.EDIT_LEDGERMAP,
        payload : ledgermap,
        txn : 'initiated',
    };
}


export function fetchLedgermap() {
    return {
        type : type.FETCH_LEDGERMAP,
    };
}


export function fetchedLedgermap(ledgermap) {
    return {
        type : type.FETCHED_LEDGERMAP,
        payload : ledgermap
    };
}


export function searchLedgermap(ledgermap) {
    return {
        type : type.SEARCH_LEDGERMAP,
        payload : ledgermap
    };
}


export function storeSearchLedgermapResult(ledgermap) {
    return {
        type : type.STORE_SEARCH_LEDGERMAP_RESULT,
        payload : ledgermap
    };
}


export function deleteLedgermap(ledgermap) {
    return {
        type : type.DELETE_LEDGERMAP,
        payload: ledgermap
    };
}


export function deletedLedgermap(msg) {
    return {
        type : type.DELETED_LEDGERMAP,
        payload : msg
    };
}


export function setNotifyDone(props) {
    return {
        type : type.NOTIFICATION_DONE_LEDGERMAP,
        payload: props
    };
}


export function filterItems(options) {
    return {
        type : type.FILTER_ITEMS,
        payload: options
    };
}